import {createFeatureFlagsStore} from '#imports';

export const FeatureFlags = ['financing-admin-ui-legal-entities-settings'] as const;
export type FeatureFlag = (typeof FeatureFlags)[number];

/**
 * features-flags store is initialized in `src/runtime/plugins/load-feature-flags`
 */
export const useFeatureFlagsStore = createFeatureFlagsStore([...FeatureFlags], 'nuxt-admin-components-feature-flags-store');
